import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("aura_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch((e) => {
      if (e?.response?.status === 403) toast.error("Il tuo account è stato sospeso dall'amministrazione");
      localStorage.removeItem("aura_token");
      setUser(false);
    });
  }, []);

  const saveSession = (data) => {
    localStorage.setItem("aura_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => saveSession((await api.post("/auth/login", { email, password })).data);
  const register = async (payload) => saveSession((await api.post("/auth/register", payload)).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("aura_token");
    setUser(false);
  };

  const refresh = () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});

  return <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
